const features = [
  {
    icon: 'ri-flashlight-line',
    title: '实时更新',
    desc: '编辑团队全天候追踪最新娱乐动态，重大突发事件15分钟内完成首发报道，每日更新超200条爆料内容，确保你永远第一时间吃到最新鲜的瓜。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '深度整理',
    desc: '每条爆料经过多方信源交叉验证，关键信息严格核实。我们标注信息来源、可信度等级和更新时间线，让你吃得明白、吃得放心，告别真假难辨的吃瓜体验。',
  },
  {
    icon: 'ri-shield-user-line',
    title: '匿名投稿',
    desc: '提供安全可靠的匿名投稿渠道，严格保护爆料人隐私。无论你是圈内人士还是知情者，都可以放心分享一线爆料线索，你的身份信息安全由我们守护。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm text-foreground-500">为什么选择51每日大赛吃瓜</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((f, i) => (
            <div key={i} className="bg-background-100 rounded-lg p-6 md:p-8 text-center transition-all duration-200 hover:scale-[1.03] cursor-pointer group">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-lg bg-primary-100 flex items-center justify-center mx-auto mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${f.icon} text-primary-600 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-3">{f.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}